<template>
    <div class="loader-wrapper" :class="determineTypeClass()">
        <div class="loader loader--full"></div>
    </div>
</template>

<script>
// TODO might want to customize for parent view
    export default {
        props: {
            type: String,
        },
        methods: {
            determineTypeClass() {
                return `loader--${this.type}`;
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'globalStyles';
    .loader-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 100%;
        height: 66vh;
    }
    .loader--full {
        width: 3em;
        height: 3em;
    }
    .loader--menu {
        height: $navigationBarHeight;
    }
	.loader--input-field {
		margin-top: 1rem;

		height: 14vh;
	}
  .loader--none {
    display: none;
  }
  .loader--store-loader {
	  width: 100vw;
		height: 100vh;
		.loader--full {
			width: 6em;
			height: 6em;
			border-top-color: $storeButtonColor;
			border-bottom-color: $storeButtonTitleColor;
			border-right-color: $storePrimaryButtonColor;
		}
	}
	.login-loader {
		max-height: 40vh;
	}
	.loader-wrapper {
		&.loader--button, &.loader--button-right {
			height: 0;
			.loader--full {
				width: 1em;
				height: 1em;
				border: 2px solid $storeButtonTitleColor;
				border-right-color: transparent;
				border-top-color: transparent;
			}
		}
		&.loader--button-right {
			position: absolute;
			top: 0.8em;
			right: 0.8em;
			width: 1em;
			height: 1em;
		}
	}
	.loader--menu-item {
		position: absolute;
		height: 100%;
		background-color: rgba(255,255,255,0.8);
		z-index: $zTopLayer;
		.loader--full {
			position: relative;
			left: 0;
		}
	}
	@include mobile {
		.loader--menu {
			height: $mobileNavigationHeight;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseLoader.vue